module.exports = __webpack_public_path__ + "static/Q1_2022_Announcement_Financial_Results-727e2e11c6fb90f4ab7d56660c1ccb11.pdf";